<template>
  <div :class="['file-preview', transparent?'transparent':'']" @click="downloadFile($event)">
    <centered-image
      v-if="isImage()"
      :src="src"
      :alt="name"
      :cover="cover"
      :thumbnail="thumbnail"
    />
    <div v-else>
      <div v-if="scale === 'large'" class="filename-area">
        {{ name }}
      </div>
      <div v-b-tooltip.hover class="image-area" :title="name">
        <file-icon :filename="filename" :scale="scale" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    cover: {
      type: Boolean,
      default: false
    },
    file: {
      type: [Object, File],
      default: undefined
    },
    width: {
      type: Number,
      default: 0
    },
    transparent: {
      type: Boolean,
      default: false
    },
    thumbnail: {
      type: Boolean,
      default: false
    },
    scale: {
      type: String,
      default: 'large'
    },
    downloadable: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      mimeType: '',
      src: '',
      marginTop: 0,
      marginLeft: 0,
      marginTopDiff: 0,
      marginLeftDiff: 0,
      filename: ''
    }
  },
  watch: {
    file: function(newVal, oldVal) {
      this.updateFile(newVal)
    }
  },
  mounted() {
    this.updateFile(this.file)
  },
  methods: {
    downloadFile(e) {
      if (this.downloadable) {
        e.stopPropagation()
        e.preventDefault()
        this.downloadFileWithTmpId(this.file.tmpId, this.filename, this.file)
      }
    },
    updateFile(file) {
      if (file.fileMimeTy) {
        this.mimeType = file.fileMimeTy
      } else {
        this.mimeType = file.type
      }
      if (this.isImage()) {
        if (file instanceof File) {
          const reader = new FileReader()
          reader.onload = e => {
            this.src = reader.result
          }
          reader.onerror = e => {
            console.error(e)
          }
          reader.readAsDataURL(file)
        } else if (file.tmpId) {
          this.src = this.getImgUrl(file, this.width)
        } else if (file.url) {
          this.src = file.url
        }
      } else if (file.fileNm) {
        this.filename = file.fileNm
      } else if (file.name) {
        this.filename = file.name
      }
    },
    isImage() {
      return this.mimeType && this.mimeType.startsWith('image/')
    }
  }
}
</script>

<style scoped>
.file-preview {
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: center;
}
.file-preview.transparent {
  background-color: transparent;
}
.filename-area {
  padding: 20px;
  position: absolute;
  left: 30px;
  top: 80px;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  max-width: calc(100% - 60px);
}
</style>
